import { ERROR } from 'constant/messages';

export const mapTransactionError = (error) => {
	switch (error) {
		case 'Invalid amount.':
			return ERROR.AMOUNT_TRANSACTION;
		case 'Insufficient balance.':
			return ERROR.INSUFFICIENT_BALANCE;
		case 'Lightning invoice has expired.':
			return ERROR.ALREADY_TRANSACTION;
		case 'Unable to find a lightning payment route.':
			return ERROR.NOT_FOUND_TRANSACTION;
		case 'Invalid lightning invoice.':
			return ERROR.INVALID_INVOICE_TRANSACTION;
		case 'Exchange rate is unavailable for the given currency pair.':
			return ERROR.EXCHANGE_TRANSACTION;
		default:
			return ERROR.FAILED_TRANSACTION;
	}
};
